import api from './axios';

// Upload a single attachment for a ticket
export const uploadAttachment = async (ticketId, file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post(`/tickets/${ticketId}/attachments`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
};

// Get all attachments for a ticket
export const getAttachments = async (ticketId) => {
  const response = await api.get(`/tickets/${ticketId}/attachments`);
  return response.data;
};

// Download an attachment (returns axios response with blob)
export const downloadAttachment = async (attachmentId) => {
  const response = await api.get(`/attachments/${attachmentId}/download`, {
    responseType: 'blob'
  });
  return response;
};

// Delete an attachment
export const deleteAttachment = async (attachmentId) => {
  const response = await api.delete(`/attachments/${attachmentId}`);
  return response.data;
};


